import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface Props {
  width: number;
  height: number;
  stroke: string;
}

const PreviousArrowIcon = (props: Props) => {
  const { width, height, stroke } = props;
  return (
    <SVGUniqueID>
      <svg
        width={width}
        height={height}
        viewBox="0 0 13 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M11.8346 5H1.16797M1.16797 5L5.16797 9M1.16797 5L5.16797 1"
          stroke={stroke}
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SVGUniqueID>
  );
};

PreviousArrowIcon.defaultProps = {
  height: 10,
  width: 13,
  stroke: '#334155'
};

export { PreviousArrowIcon };
